import React from "react";
import { LoaderContainer, LoaderImage } from "./LoaderElements";

const LoaderDocuments = ({ isLoading }) => {
  if (!isLoading) return null;
  return (
    <LoaderContainer>
      <LoaderImage src="https://react-pdf.org/images/logo.png" alt="loader" />
    </LoaderContainer>
  );
};

export default LoaderDocuments;
